import BGImg7 from "../../assets/img/bg/test-bg.png";
import Slider from "react-slick";
import Icon from "../../assets/img/testimonial/qt-icon.png";
import { useTranslation } from "react-i18next";

const Img1 = "https://lh3.googleusercontent.com/a-/ALV-UjXqgwPqRLFAIkWONaxLEcT4VGR-c2Mfqiy8j3Tr_kL7tFzMrWmzQg=w119-h119-p-rp-mo-br100";
const Img2 = "https://lh3.googleusercontent.com/a-/ALV-UjXohvA9dFm0QHfRjz3Be2kiW3SeqAx8lXfus-VHLK-WJV5Udc6fLA=w119-h119-p-rp-mo-br100";
const Img3 = "https://lh3.googleusercontent.com/a-/ALV-UjXP_zANu1hYEqXnx5RGYa_ydXbtoDh0B3iEKOrJ883omwgZW8g=w119-h119-p-rp-mo-br100";
const Img4 = "https://lh3.googleusercontent.com/a-/ALV-UjVnIh9NpfGmaS_IAkh2FsqSczx7C0WrMZPKaPPsgmtuNM1RHzdp=w108-h108-p-rp-mo-br100";

const Testimonial = () => {
  const { t } = useTranslation();

  // Avatar sizes come straight out of the Google URL (…=w119-h119…), so each
  // avatar can declare the box it will occupy and stop the row from reflowing.
  const testimonials = [
    { img: Img1, w: 119, h: 119, name: "Milica Petrovic", text: t('testimonial.t1') },
    { img: Img2, w: 119, h: 119, name: "Tijana Milic",    text: t('testimonial.t2') },
    { img: Img3, w: 119, h: 119, name: "Tanja Zivkovic",  text: t('testimonial.t3') },
    { img: Img4, w: 108, h: 108, name: "Aleksandra Gajic",text: t('testimonial.t4') },
  ];

  const settings = {
    initialIndex: 2,
    dots: true,
    arrows: false,
    infinite: true,
    speed: 900,
    autoPlay: true,
    slidesToShow: 2,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 2, slidesToScroll: 1, infinite: true, dots: true } },
      { breakpoint: 992,  settings: { slidesToShow: 1, slidesToScroll: 1 } },
      { breakpoint: 767,  settings: { slidesToShow: 1, slidesToScroll: 1 } },
    ],
  };

  return (
    <>
      <section
        className="testimonial-area pt-120 p-relative fix"
        style={{
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundImage: `url(${BGImg7})`,
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              <div className="section-title mb-50 wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s">
                <h2>{t('testimonial.heading')}</h2>
                <p className="mt-15">{t('testimonial.subtext')}</p>
              </div>
            </div>
            <div className="col-lg-8">
              <Slider className="testimonial-active" {...settings}>
                {testimonials.map(({ img, w, h, name, text }) => (
                  <div key={name} className="single-testimonial">
                    <div className="testi-author">
                      <img src={img} alt={name} width={w} height={h} />
                      <div className="ta-info">
                        <h6>{name}</h6>
                        <span>{t('testimonial.client')}</span>
                      </div>
                    </div>
                    <p>{text}</p>
                    <div className="qt-img">
                      <img src={Icon} alt="img" width="59" height="51" />
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Testimonial;
